var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.1589 1.24445 2.7069 5.48486c.1882.38148.5522.64581.9732.70688l6.0531.8796c1.0603.15419 1.4833 1.45682.7163 2.20421l-4.3799 4.2694c-.3044.2969-.4436.7249-.3715 1.1439l1.0338 6.0286c.1812 1.0558-.9272 1.8608-1.8753 1.3627l-5.4138-2.8461c-.3765-.1978-.8265-.1978-1.203 0l-5.41378 2.8461c-.94818.4986-2.05657-.3069-1.87534-1.3627l1.03379-6.0286c.07209-.419-.06709-.847-.37147-1.1439l-4.379971-4.2694c-.766959-.74789-.3439299-2.05052.716391-2.20421l6.05307-.8796c.42103-.06107.78498-.3254.97322-.70688l2.70689-5.48486c.4736-.960699 1.8433-.960699 2.3174 0z",
    fill: "#ffcc09"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c2738f576e63212c7e1f0e6c5653d64a.svg";
export { ForwardRef as ReactComponent };